import React from 'react'
import { Button, Card, Col, Flex, Row, Form, Typography, Image, Divider } from 'antd'
import {Breadcrumb, MyInput, UnderlineDesign } from '../../components'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { actionsApi } from '../../shared'
import { useDispatch, useSelector } from 'react-redux'

const { Text, Title } = Typography
const Login = () => {
    
    const dispatcher = useDispatch()
    const [form] = Form.useForm()
    const { loading } = useSelector(state => state?.loginAndSignUp)
    
    const login = () => {
        dispatcher(actionsApi?.login(form.getFieldsValue(['email', 'password'])))
    }
  return (
    <>
        <Breadcrumb title='Sign In' pageName='Sign In' breadcrumb={[{to:'/',name:'Home'}]}/>    
        <div className='padding-t mb-3'>
            <div className='container'>    
                <Row justify={'center'}>
                    <Col lg={{span: 12}} md={{span: 12}} sm={{span: 24}} xs={{span: 24}}>
                        <Card className='card-pro my-5'>
                            <Flex vertical align="center" justify="center" gap={15}>
                                <motion.div
                                    initial={{ y: '-100%', opacity: 0 }}
                                    whileInView={{
                                        opacity: 1,
                                        y: 0,
                                    }}
                                    transition={{ delay: .1, duration: .3, }}
                                    viewport={{once: true}}>
                                    <Image
                                        src={"/assets/images/logo.png"}
                                        alt='Nextdoor Pros'
                                        preview= {false}
                                        width={'100px'}
                                    />
                                </motion.div>
                                <Flex vertical gap={3} align='center'>
                                    <motion.div
                                        initial={{ y: '-100%', opacity: 0 }}
                                        whileInView={{
                                            opacity: 1,
                                            y: 0,
                                        }}
                                        transition={{ delay: .1, duration: .3, }}
                                        viewport={{once: true}}>
                                        <Flex vertical className='mb-2' align='center'>
                                            <Title 
                                                level={3} 
                                                className="gradient-text m-0"
                                                >
                                                Welcome to Nextdoor Pros
                                            </Title>
                                            <UnderlineDesign />
                                        </Flex>
                                    </motion.div>
                                    <motion.div
                                        initial={{ y: '-100%', opacity: 0 }}
                                        whileInView={{
                                            opacity: 1,
                                            y: 0,
                                        }}
                                        transition={{ delay: .1, duration: .3, }}
                                        viewport={{once: true}}>
                                        <Text 
                                            level={5} 
                                            className="text-gray"
                                            >
                                            Please <strong className='text-brand'>Sign In</strong> to enter credentials
                                        </Text>
                                    </motion.div>
                                </Flex>
                            </Flex>
                            <motion.div
                                initial={{ y: '100%', opacity: 0 }}
                                whileInView={{
                                    opacity: 1,
                                    y: 0,
                                }}
                                transition={{ delay: .1, duration: .3, }}
                                viewport={{once: true}}
                            >
                                <Form 
                                    form={form}
                                    layout='vertical'
                                    requiredMark={false}
                                    className='mt-3'
                                    onFinish={login}
                                >
                                    <Row gutter={[16, 16]}>
                                    
                                        <Col span={24}>
                                            <MyInput 
                                                label='Email'
                                                name='email'
                                                required
                                                message='Please enter email'
                                                placeholder='example@example.com'
                                            />
                                        </Col>
                                        <Col span={24}>
                                            <MyInput 
                                                label='Password'
                                                type='password'
                                                name='password'
                                                required
                                                message='Please enter password'
                                                placeholder=''
                                            />
                                        </Col>
                                        <Col span={24}>
                                            <Flex justify="space-between" className="mt-2">
                                                {/* <Checkbox className='text-gray'>Remember me</Checkbox> */}
                                                <Link to={'/forgotpassword'} className="fs-13 text-gray">
                                                    Forgot Password?
                                                </Link>
                                            </Flex>
                                        </Col>
                                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                            <Button className="btn rounded mt-2" block htmlType='submit' loading={loading}>Sign In</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </motion.div>
                            <motion.div
                                initial={{ y: '-100%', opacity: 0 }}
                                whileInView={{
                                    opacity: 1,
                                    y: 0,
                                }}
                                transition={{ delay: .1, duration: .3, }}
                                viewport={{once: true}}
                            >
                                <Divider style={{borderColor:'gray'}} className='text-gray mt-4'>
                                    OR
                                </Divider>
                            </motion.div>
                            <motion.div
                                initial={{ y: '-100%', opacity: 0 }}
                                whileInView={{
                                    opacity: 1,
                                    y: 0,
                                }}
                                transition={{ delay: .1, duration: .3, }}
                                viewport={{once: true}}
                            >
                                <Flex gap={10} justify='center' className='mt-3'>
                                    <Text className='text-gray'>
                                        If you don't have an account then Sign Up
                                        <Link to={'/registeraspro'} className='px-2 text-brand'>
                                            <strong> as Pro</strong>
                                        </Link>
                                        or <Link to={'/registerasclient'} className='px-2 text-brand'>
                                            <strong> as Client</strong>
                                        </Link>
                                    </Text>
                                </Flex>
                            </motion.div>
                        </Card>  
                    </Col>
                </Row>
            </div>
        </div>
    </>
  )
}

export {Login}